<app-breadcrumb [title]="'تقرير التبرعات '" [items]="['Tables', 'Bootstrap Tables']" [active_item]="'Basic'">
</app-breadcrumb>

<div class="container-fluid">
  <div class="card">
    <div class="card-body">
      <div class="form-row">
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for=""> من تاريخ </label>
            <input type="date" class="form-control" [(ngModel)]="ReportsInfo.FromDate">
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="form-group">

            <label for=""> الى تاريخ </label>


            <input type="date" class="form-control" [(ngModel)]="ReportsInfo.ToDate">
          </div>
        </div>
        <div class="col-6 mb-3" >
          <label for="">المشروع</label>
          <ng-select class="form-control p-0" aria-label="Default select example"
            [(ngModel)]="ReportsInfo.Project" (change)="SelectProject($event?.id)" [items]="projects"
            bindLabel="title" bindValue="id">
          </ng-select>
        </div>

        <div class="col-6  mb-3" >
          <label for="">الكود المرجعي</label>
          <!-- <input class="form-control" id="validation01" type="text" [(ngModel)]="ReportsInfo.RefCodeID" containerClass="" /> -->
            <ng-select class="form-control p-0" aria-label="Default select example"
            [(ngModel)]="ReportsInfo.RefCodeID" (change)="SelectRefCode($event?.id)" [items]="RefCodes"
            bindLabel="refCode" bindValue="id">
          </ng-select>
        </div>

        <div class="col-6 mb-3">
          <label for="">تجميع بواسطة</label>
          <ng-select class="form-control p-0" aria-label="Default select example"
             (change)="SelectGroupBy($event?.id)" [items]="GroupBy"
            bindLabel="name" bindValue="id">
          </ng-select>
        </div>


      </div>
      <div class="d-flex justify-content-end lign-items-center ">
        <button class="addnew-btn" style="margin-top: 41px;" type="submit" (click)="Viewreports()">عرض التقرير</button>
      </div>
    </div>
  </div>

</div>